import type { APIError } from "@be-miniapp/types"

/**
 * Converts an API error to a toast message.
 *
 * @param error The API error object.
 * @returns The toast message object.
 */
const fromAPIErrorToToastMessage = (error: APIError): any => {
  return {
    variant: "error",
    description: error?.message || error?.error || "Vui lòng thử lại sau",
  }
}

export { fromAPIErrorToToastMessage }
